/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.6.29",
    versionName: "0.2.0-nightly.2025.6.29",
    versionChannel: "nightly",
    buildDate: "2025-06-29T00:08:43.286Z",
    commitHash: "355d4135764e4c327ec73c2e0883a591ac7b1c5b",
};
